import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export abstract class Resolvable<T>  {
    /**
     * Value that is returned when the initialization fails
     * This is so that the application can still function when the initialization fails
     */
    protected abstract readonly FALLBACK_VALUE: T;

    /**
     * Name of the type of data that is resolved
     * Used for logging purposes
     * EX. `Error while fetching resolvable FieldDefinition data`
     */
    protected abstract readonly TYPE_NAME: string;

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): T | Observable<T> | Promise<T> {
        return this.initialize().pipe(
            catchError(error => {
                console.error(`Error while fetching resolvable ${this.TYPE_NAME} data`, error);
                return of(this.FALLBACK_VALUE);
            })
        );
    }

    protected abstract initialize(): Observable<T>;
}
